import { useNavigation } from "@react-navigation/native";
import React from "react";
import {
  FlatList,
  StyleSheet,
  Text,
  TouchableNativeFeedback,
  View,
} from "react-native";
import Image from "@components/common/Image";
import DefaultCatImage from "@assets/svg/default_cat";
import analytics from "@services/analytics";
import {
  CAT_NAV_EVENTS,
  CAT_NAV_SOURCES,
} from "../../constants/analyticsEventsCT";

const CategoryItem = (props) => {
  const navigation = useNavigation();
  const { item } = props;

  const navigateToCatNav = (cat, subItem) => {
    navigation.navigate("CategoryNavigationScreen", {
      selectedCat: cat,
      selectedSubCat: subItem.c_id,
    });
    analytics.trackEvent(CAT_NAV_EVENTS.SUB_CAT_CLICKED, {
      source: CAT_NAV_SOURCES.CAT_EX,
      cat: item.name_hi,
      sub: subItem.name_hi,
      ptype: null,
    });
  };

  const renderItem = ({ item: subItem }) => {
    return (
      <TouchableNativeFeedback
        onPress={() => {
          navigateToCatNav(item.c_id, subItem);
        }}
      >
        <View style={styles.categoriesItem}>
          <Text
            ellipsizeMode="tail"
            numberOfLines={2}
            style={styles.categoriesItemText}
          >
            {subItem.name_hi}
          </Text>

          {subItem.c_img ? (
            <Image
              source={{ uri: subItem.c_img }}
              style={styles.categoriesItemImage}
              resizeMode={Image.resizeMode.contain}
            />
          ) : (
            <DefaultCatImage />
          )}
        </View>
      </TouchableNativeFeedback>
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.categoriesTitle}>
        <Text style={styles.categoriesItemTitle}>{item.name_hi} </Text>
      </View>

      <FlatList
        horizontal
        showsHorizontalScrollIndicator={false}
        renderItem={renderItem}
        data={item.sub_categories}
        contentContainerStyle={styles.flatList}
        keyExtractor={(i) => i.name_hi}
        decelerationRate="fast"
        snapToInterval={110 + 6}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
  },
  categoriesTitle: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    paddingTop: 20,
    paddingBottom: 6,
  },
  categoriesItem: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    marginRight: 6,
    height: 110,
    width: 110,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.1)",
    alignItems: "center",
  },
  categoriesItemText: {
    fontSize: 12,
    lineHeight: 14,
    textAlign: "center",
    color: "rgba(0,0,0,0.86)",
    paddingHorizontal: 6,
    paddingTop: 8,
    flex: 2,
    fontFamily: "Muli-SemiBold",
  },
  categoriesItemImage: {
    height: 70,
    width: "100%",
    marginVertical: 2,
  },
  categoriesItemTitle: {
    color: "rgb(0, 0, 0)",
    fontSize: 20,
    paddingLeft: 15,
  },
  flatList: {
    paddingHorizontal: 15,
  },
});

export default CategoryItem;
